/**********************************************
  EXPANDERS EXPLAINED:

  Take a route from of the sitemap generation process,
  return a promise for thenable routes - to be flattened when the sitemap is generated

*//////////////////////////////////////////////

import config from "config";

import logger from 'logger';
import ApiClient from "utils/ApiClient";
import { slugifyName } from "utils";
import { isInThePast, getRelativeDay } from "utils/LocalDateTimeHelper";

import { nDayArrFactoryForwards, nDayArrFactoryBackwards, nDayArrFactoryBoth, stripTZD } from "utils/sitemapUtils";

const client = new ApiClient();

export function racecardForDatesExpander({url, sitemap: { changefreq, priority }}) {
  const routeArray = [];
  const dateArray = nDayArrFactoryForwards();

  return new Promise(resolve => {
    for (const date of dateArray) {
      const urlDate = getRelativeDay(date, 0, {convertToday: true, convertTomorrow: true});
      routeArray.push({ url: url.replace(":date", urlDate), sitemap: {changefreq, priority}});
    }
    return resolve(routeArray);
  });
}

export function resultsExpander({url, sitemap: { changefreq, priority }}) {
  const routeArray = [];
  const dateArray = nDayArrFactoryBackwards();

  return new Promise(resolve => {
    for (const date of dateArray) {
      const urlDate = getRelativeDay(date, 0, {convertToday: true, convertYesterday: true});
      routeArray.push({ url: url.replace(":date", urlDate), sitemap: {changefreq, priority}});
    }
    return resolve(routeArray);
  });
}

export function racecardExpander({url, sitemap: { changefreq, priority }}) {
  const routeArray = [];
  const dateArray = nDayArrFactoryBoth();

  const promiseStack = [];

  for (const date of dateArray) {
    promiseStack.push(
      client.get(`${config.api.horseRacing.loadMeetings}/${date}`)
        .then(result => result)
        .catch(err => {
          logger.debug(err);
          return [];
        })
    );
  }

  return Promise.all(promiseStack)
    .then(results => {
      for (const day of results) {
        for (const {meeting_summary, races} of day) {
          const {
            date: meetingDate,
            course: {
              name: courseName
            }
          } = meeting_summary;
          for (const {race_summary_reference: { id: raceId }, name: raceName, date: raceDate, time: raceTime, off_time: raceOffTime} of races) {
            if (meetingDate && courseName && raceId && raceName) {
              const isInPast = raceOffTime ? isInThePast(`${raceDate}T${raceOffTime}Z`) : isInThePast(`${raceDate}T${raceTime}Z`);
              routeArray.push({
                url: url.replace(":date", meetingDate)
                        .replace(":courseSlug", slugifyName(courseName))
                        .replace(":raceId", raceId)
                        .replace(":raceSlug", slugifyName(raceName)),
                sitemap: {
                  changefreq,
                  priority,
                  lastmodISO: isInPast ?
                    raceOffTime ?
                      `${raceDate}T${stripTZD(raceOffTime)}Z`
                    :
                      `${raceDate}T${stripTZD(raceTime)}Z`
                  :
                    undefined
                }
              });
            } else {
              logger.debug(`The following horserace has an issue, and won't be added to the sitemap: ${meetingDate} ${courseName} ${raceId} ${raceName}`);
            }
          }
        }
      }
      return routeArray;
    });
}

export function abcFiveDayExpander({url, sitemap: { changefreq, priority }}) {
  let routeArray = [];
  const days = ['5-days'];
  const tableTypes = ['horses'];
  const letterRanges = ['a-d', 'e-l', 'm-r', 's-z'];

  for (const day of days) {
    for (const tableType of tableTypes) {
      for (const letterRange of letterRanges) {
        routeArray.push({
          url: url.replace(":days", day)
                  .replace(":type", tableType)
                  .replace(":letterRange", letterRange),
          sitemap: {
            changefreq,
            priority
          }
        })
      }
    }
  }
  return routeArray;
}

export function abcTypeExpander({url, sitemap: { changefreq, priority }}) {
  let routeArray = [];
  const days = ['today'];
  const tableTypes = ['jockeys', 'trainers'];

  for (const day of days) {
    for (const tableType of tableTypes) {
      routeArray.push({
        url: url.replace(":days", day)
                .replace(":type", tableType),
        sitemap: {
          changefreq,
          priority
        }
      })
    }
  }
  return routeArray;
}

export function abcDaysExpander({url, sitemap: { changefreq, priority }}) {
  let routeArray = [];
  const days = ['tomorrow', '5-days'];

  for (const day of days) {
    routeArray.push({
      url: url.replace(":days", day),
      sitemap: {
        changefreq,
        priority
      }
    })
  }
  return routeArray;
}



// WEBPACK FOOTER //
// ./modules/HorseRacing/sitemap-helper.js